<template>
    <div class="input-group bootstrap-touchspin">
        <span class="input-group-prepend">
            <button
                class="btn btn-light bootstrap-touchspin-down legitRipple"
                type="button"
                @click="decrement"
                :disabled="disabled || (min !== null && modelValue <= min)"
            >–</button>
        </span>
        <input
            type="number"
            class="form-control touchspin-postfix no-arrow"
            style="display: block; text-align: center;"
            :value="modelValue"
            @input="onInput"
            @blur="onBlur"
            :min="min"
            :max="max"
            :step="step"
            :disabled="disabled"
        >
        <span class="input-group-append">
            <button
                class="btn btn-light bootstrap-touchspin-up legitRipple"
                type="button"
                @click="increment"
                :disabled="disabled || (max !== null && modelValue >= max)"
            >+</button>
        </span>
    </div>
</template>

<script>
export default {
    name: "AppTouchSpinInput",
    props: {
        modelValue: {
            type: [Number, String],
            default: 0
        },
        min: {
            type: Number,
            default: null
        },
        max: {
            type: Number,
            default: null
        },
        step: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    methods: {
        updateValue(value) {
            let newValue = parseFloat(value);
            
            if (isNaN(newValue)) {
                newValue = (this.min !== null) ? this.min : 0;
            }

            this.$emit('update:modelValue', newValue);
        },
        onInput(event) {
            this.updateValue(event.target.value);
        },
        onBlur(event) {
            let value = parseFloat(event.target.value);
            if (isNaN(value)) {
                value = (this.min !== null) ? this.min : 0;
            }
            
            if (this.min !== null && value < this.min) {
                value = this.min;
            }
            if (this.max !== null && value > this.max) {
                value = this.max;
            }
            
            if (value !== this.modelValue) {
                this.$emit('update:modelValue', value);
                event.target.value = value;
            }
        },
        increment() {
            let currentValue = parseFloat(this.modelValue) || 0;
            let newValue = currentValue + this.step;
            if (this.max !== null && newValue > this.max) {
                newValue = this.max;
            }
            this.$emit('update:modelValue', newValue);
        },
        decrement() {
            let currentValue = parseFloat(this.modelValue) || 0;
            let newValue = currentValue - this.step;
            if (this.min !== null && newValue < this.min) {
                newValue = this.min;
            }
            this.$emit('update:modelValue', newValue);
        }
    }
}
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    .no-arrow::-webkit-outer-spin-button,
    .no-arrow::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    .no-arrow {
      -moz-appearance: textfield;
    }
</style>
